import { type ErrorComponentProps, Link } from "@tanstack/react-router";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { ApiError } from "@/lib/api-client";
import { ForbiddenPage } from "./ForbiddenPage";
import { NotFoundPage } from "./NotFoundPage";

export function ErrorPage({ error }: ErrorComponentProps) {
	// 403 Forbidden -> dedizierte Seite
	if (error instanceof ApiError && error.status === 403) {
		return <ForbiddenPage />;
	}

	// 404 Not Found -> dedizierte Seite
	if (error instanceof ApiError && error.status === 404) {
		return <NotFoundPage />;
	}

	const message =
		error instanceof Error ? error.message : "Ein unerwarteter Fehler ist aufgetreten.";

	return (
		<div className="min-h-screen bg-background flex items-center justify-center px-4">
			<div className="text-center max-w-md">
				<div className="mb-6 text-error" aria-hidden="true">
					<AlertTriangle size={64} className="mx-auto" />
				</div>
				<h1 className="text-4xl font-bold text-text mb-2">Fehler</h1>
				<p className="text-text-secondary mb-8">{message}</p>
				<div className="flex justify-center gap-3">
					<Button variant="outline" onClick={() => window.location.reload()}>
						Seite neu laden
					</Button>
					<Link to="/search">
						<Button variant="primary">Zur Startseite</Button>
					</Link>
				</div>
			</div>
		</div>
	);
}
